export class FilterOptionState {
  private active: boolean;

  private count: number;

  constructor(active: boolean = false, count: number = 0) {
    this.active = active;
    this.count = count;
  }

  copy() {
    return new FilterOptionState(this.active, this.count);
  }

  isActive() {
    return this.active;
  }

  toggleActivationState() {
    this.active = !this.active;
  }

  getCount(): number {
    return this.count;
  }

  resetCount() {
    this.count = 0;
  }

  incCount() {
    this.count += 1;
  }

  setCount(count: number) {
    this.count = count;
  }
}
